import { useAdministrativeContext } from '../../../../../pages/administrativePanel/administrativePanelContext'
import { SpaceLoader } from '../../../../loaders/spaceLoader'
import { useAuth } from '../../../../../context/AuthContext'
import { formatMoney } from '../../../../../Utils/formatMoney'
import { api } from '../../../../../services/api'
import { useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import { BarGraphics } from '../BarGraphics'
import { ExportFiles } from '../ExportFiles'
import { FiMoreVertical } from 'react-icons/fi'
import { download_csv } from '../JsonToCsv'
import { PDFGenerator } from '../PDFGenerator'
import moment from 'moment'

import { Container, ContainerLoading } from './style'


export function PaymentTypesDetailed() {
    const { 
        startDate, 
        endDate, 
        listBusinessToFilter,
        listSalesChannelsId 
    } = useAdministrativeContext()
    const [paymentTypesResume, setPaymentTypesResume] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [isOpenExcelButton, setIsOpenExcelButton] = useState(false)
    const { signOut } = useAuth()

    let docTitle = `Formas de Pagamento ${moment(startDate).format('DD-MM-YYYY-HH:mm')} até ${moment(endDate).format('DD-MM-YYYY-HH:mm')}`

    const totalValuePaymentMethods = useMemo(() => 
           paymentTypesResume.reduce((acc, paymentMethod) => {
                return acc + paymentMethod.value
            }, 0)
    , [paymentTypesResume])
    
    function handleDownloadCSV() {
        const newArr = paymentTypesResume.map((data) => {
            return{
                Codigo: data.id,
                Forma_Pagamento: data.name,
                Total: Number(data.value).toFixed(2).replace('.',',')
            }
        })

        download_csv(newArr, docTitle)
    }

    function handleDownloadPDF() {
        const bodyContent = {
            tableHeader: [
                {text: "Tipo", style: "header"},
                {text: "Valor", style: "header"},
            ],
            lines: [], 
            widths: ['*', '*']
        }
        
        for (let [index, paymentMethod] of paymentTypesResume.entries()) {
            const rows = []
            const isEven = index % 2 === 0

            rows.push({
                text: paymentMethod.name, 
                style: `${isEven ? "line" : "lineGray"}`
            })
            rows.push({
                text: formatMoney(paymentMethod.value), 
                style: `${isEven ? "line" : "lineGray"}`
            })

            bodyContent.lines.push(rows)
        }

        bodyContent.lines.push([
            { text: 'TOTAL', style: 'total' },
            { 
                text: formatMoney(totalValuePaymentMethods), 
                style: 'total' 
            }
        ])
       
        PDFGenerator(docTitle, bodyContent)
    }

    useEffect(() => {
        async function fetchData() {
            let obj = {
                startDate: startDate,
                endDate: endDate,
                business: listBusinessToFilter,
                complete: true,
                salesChannels: listSalesChannelsId
            }
                try{
                    await api.post('/getPaymentTypesGraphic' , obj, {
                        headers: {
                            'Content-Type': 'application/json',
                            token: localStorage.getItem('@Inoveclube:token')
                        }
                    }).then(response => setPaymentTypesResume(response.data))
    
                    setIsLoading(false)
    
                }catch(error){
                    if(error.response){
                        if(error.response.status === 401 || error.response.status === 500){
                            signOut()
                            toast.warning('Sua sessão foi expirada')
                        }else{
                            toast.error(error.response.data.message)
                        }
                    }else{
                        toast.error(error.message)
                    }        
                }
        }

        fetchData()
    }, [endDate, startDate, listBusinessToFilter, signOut, listSalesChannelsId])


    
    if(isLoading)
        return(
            <ContainerLoading>

                 <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />
                 
            </ContainerLoading>
        )  


    return(
        <Container>
            <div className="seeMore"> 
                <FiMoreVertical 
                     onClick={() => setIsOpenExcelButton(!isOpenExcelButton)}
                />
                
                <ExportFiles 
                    handleDownloadCSV={handleDownloadCSV}
                    isOpen={isOpenExcelButton}
                    setIsOpen={setIsOpenExcelButton}
                    pdfButtonIsVisible={true}
                    pdfConverter={handleDownloadPDF}
                />
            </div>

            <BarGraphics 
                datasForGraphic={paymentTypesResume}
                isExportButtonVisible={isOpenExcelButton}
            />

        </Container>
    )
}
